<!--
 * @ Author: Your name
 * @ Create Time: 2019-05-30 14:58:54
 * @ Modified by: Your name
 * @ Modified time: 2019-08-02 17:14:48
 * @ Description: 设备管理弹窗
 -->

<template>
  <div class="dialog-wrapper">
    <el-form :model="dialogFormData" label-width="140px" :rules="rules"
      label-position="right" ref="dialogForm"
      v-loading="formLoading" class="dialog-form" :inline="true">
      <el-row :gutter="10">
        <el-col :span="12" class="cols">
          <el-form-item label="智能柜编号" prop="deviceNumber">
            <el-input
              v-if='type==="add"'
              size="small" v-model="dialogFormData.deviceNumber"
              placeholder="智能柜编号" clearable />
            <el-input
              v-else
              size="small" v-model="dialogFormData.deviceNumber"
              placeholder="智能柜编号" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="智能柜名称" prop="deviceName">
            <el-input
              size="small" v-model="dialogFormData.deviceName"
              placeholder="智能柜名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="管理员姓名" prop="managerName">
            <el-input
              size="small" v-model="dialogFormData.managerName"
              placeholder="管理员姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="管理员手机号" prop="managerPhone">
            <el-input
              size="small" v-model="dialogFormData.managerPhone"
              placeholder="管理员手机号" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="管理员员工号" prop="managerJobCard">
            <el-input
              size="small" v-model="dialogFormData.managerJobCard"
              placeholder="管理员员工号" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12" class="cols">
          <el-form-item label="智能柜连接密码" prop="deviceConnPass">
            <el-input
              size="small" v-model="dialogFormData.deviceConnPass"
              placeholder="智能柜连接密码" clearable />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import dialog from '../../mixins/dialog'
import { DEVICE_MANAGE } from '../../libs/api'
import { onlyNumberLetter } from '../../libs/utils/validCheck'

export default {
  mixins: [dialog],
  data() {
    return {
      formLoading: false,
      dialogFormData: {
        deviceNumber: '', // 智能柜编号
        deviceName: '', // 智能柜名称
        deviceConnPass: '', // 智能柜连接密码
        managerPhone: '',
        managerName: '',
        managerJobCard: ''
      },
      rules: {
        deviceNumber: [{
          required: true, message: '请输入智能柜编号', trigger: 'change', max: 100
        },
        { validator: onlyNumberLetter, trigger: 'blur' }],
        deviceName: {
          required: true, message: '请输入智能柜名称', trigger: 'change', max: 100
        },
        deviceConnPass: [{
          required: true, message: '请输入智能柜连接密码', trigger: 'change', max: 100
        },
        { validator: onlyNumberLetter, trigger: 'blur' }],
        managerPhone: [{ validator: this.correctPhone, trigger: 'blur' }]
      },
      editUrl: DEVICE_MANAGE.EDIT_LIST, // 修改路径
      findByIdUrl: DEVICE_MANAGE.FIND_BY_ID
    }
  },
  methods: {
    correctPhone(rule, value, callback) {
      const valid = /^1[3456789]\d{9}$/.test(value)
      if (value) {
        if (!valid) {
          callback(new Error('请输入正确的手机号格式'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
  }
}
</script>
<style lang="scss" scoped >
/deep/.el-form-item__content{
  width: 215px;
}
</style>
